import React, { useState, useEffect } from 'react';
import "./Work.scss";
import AppWrap from "../../Wrapper/AppWrap";
import { client, urlFor } from "../../sanity_client/client";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";

const Work = () => {

    const [ projects, setProjects ] = useState([])

    useEffect(()=>{
        // fetch data from sanity
        const query = '*[_type =="works"] | order(_createdAt desc)';
        client.fetch(query).then((data) => {
            console.log(data)
            setProjects(data)
        })
    },[])

    return (
        <div className="work_section">
            <h2 className="head-text">
                <span>Works </span> completed
            </h2>

            <div className = "app__work-portfolio">
                {projects.map((work, index)=>(
                    // WORK ITEM 
                    <motion.div 
                        key={work.title + index} 
                        className="app__work-item"
                        whileInView={{
                            opacity: [0, 1],
                            y:[100, 0],
                            transition:{duration: 0.3},
                            scale:[0.8, 1],
                            delay:0.3
                        }}
                    >
                        <div className="app__work-img app__flex">
                            <img src={urlFor(work.imgUrl)} alt={work.title} />
                            <motion.div className="app__work-hover app__flex"
                                whileHover = {{opacity:[0,1]}}
                                whileTap={{opacity:[0,1]}}
                                transition={{duration:0.25, ease:"easeInOut"}}
                            >
                                {work.projectLink && (  <a href={work.projectLink} target="_blank" rel="noreferrer">
                                    <motion.div className="app__flex"
                                        whileInView={{scale:[0,1]}}
                                        whileHover={{ scale: [1, 0.90] }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        <AiFillEye />
                                    </motion.div>
                                </a>)}

                                {work.codeLink && (<a href={work.codeLink} target="_blank" rel="noreferrer">
                                    <motion.div className="app__flex"
                                        whileInView={{scale:[0,1]}}
                                        whileHover={{ scale: [1, 0.90] }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        <AiFillGithub />
                                    </motion.div>
                                </a>)}
                            </motion.div>
                        </div>

                        <div className="app__work-content">
                            <h4 className="bold-text">{work.title}</h4>
                            <p className="p-text" style={{marginTop:10}}>{work.description}</p>

                            <div className="app__work-tag ">
                                {work.tags.map((tag, index)=>(
                                    <p key={tag + index}>
                                        {tag}
                                    </p>
                                ))}
                            </div>

                        </div>
                    </motion.div>
                ))}
            </div>

        </div>
    )
}

export default AppWrap(Work, "work")